import { graphDefault } from './';
export const graphLabelText = (theme, parameters) => {
  const graphDefaultPattern = graphDefault(theme, parameters);
  const common = {
    fontFamily: graphDefaultPattern.fontFamily?.default,
    fontStyle: graphDefaultPattern.fontStyle,
    fontWeight: graphDefaultPattern.fontWeight.bold
  };
  switch (theme.baseThemeName) {
    case 'dark':
      {
        return {
          ...common,
          textColor: graphDefaultPattern.n5,
          fontSize: graphDefaultPattern.fontSize.m
        };
      }
    case 'high-contrast':
      {
        return {
          ...common,
          textColor: graphDefaultPattern.white,
          fontSize: graphDefaultPattern.fontSize.l
        };
      }
    default:
      {
        return {
          ...common,
          textColor: graphDefaultPattern.n_3,
          fontSize: graphDefaultPattern.fontSize.m
        };
      }
  }
};
//# sourceMappingURL=graphLabelText.js.map